import { FormattedMessage } from 'react-intl';

import { WalletCashOutStatus } from '@share/common-types';

import './style.scss';

// What the member is told for each backend status. A cash-out is not instant: Requested and Ordered
// are normal, non-terminal states, not errors.
const STATUS_CLASS: Record<WalletCashOutStatus, string> = {
  Requested: 'processing',
  Ordered: 'processing',
  FlaggedForReview: 'processing',
  NeedsReview: 'review',
  Delivered: 'delivered',
  DeliveryFailed: 'delivered',
  Failed: 'failed',
  Canceled: 'failed',
  Reversed: 'reversed',
};

interface IProps {
  status: WalletCashOutStatus;
}

export function CashOutStatus(props: IProps) {
  const { status } = props;
  const className = STATUS_CLASS[status] ?? 'processing';

  return (
    <span className={`cash-out-status cash-out-status--${className}`}>
      <FormattedMessage id={`wallet.cashout.status.${className}`} defaultMessage={status} />
    </span>
  );
}
